import "./TechCard.scss";

const TechCard = ({ image, content, targetUrl, description}) => {
    const handleClick = (targetUrl) => {
      window.open(targetUrl, "_blank");
    };
  return (
    <div className="techcard">
      <img className="techcard__image" src={image} alt="title" />
      <div className="techcard__content">
        <p className="techcard__text" onClick={() => handleClick(targetUrl)}>
          {content}
        </p>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default TechCard;
